import $ from 'jquery';
import 'slick-carousel';

const MobNewsSlider = () => {
  const newsMobCarousel = $('.page-blocks__slides');

  newsMobCarousel.slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    infinite: false,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: 'unslick',
      },
    ],
  });
};

export default MobNewsSlider;
